/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useState } from 'react'
import styled from 'styled-components'
import dynamic from 'next/dynamic'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useCourse } from 'querys/course'
import { PlayAnimated, playAnimation } from 'components/icons'
import PaymentStatus from 'course/payment-status'

const VideoCardLazy = dynamic(
  () => import('../../course/video-card-lazy'),
  {
    loading: () => (
      <div className="video-thumb" id="video-card-hover">
        <img width="436" height="244.5625" src="https://i.vimeocdn.com/video/994529532_640x360.jpg?r=pad" alt="thumbnail del video de la presentacion del curso" loading="lazy" />
        <div className="video-loading">
          <CircularProgress
            variant="indeterminate"
            size={60}
            thickness={6}
          />
        </div>
      </div>
    ),
  },
)

const VideoCardStyled = styled.section`
  margin-block-start: var(--headerBlockSize);
  grid-area: videoCard;
  background: var(--basePrimary);
  box-sizing: border-box;
  border-radius: 8px;
  z-index: 2;
  position: relative;
  .center {
    display: flex;
    align-items: center;
    .thumb {
      margin-right: 8px;
    }
  }
  .video {
    overflow: hidden;
  }
  .video-thumb {
    position: relative;
    cursor: pointer;
    ${playAnimation}
    .thumb {
      width: 100%;
      height: auto;
    }
    .video-loading, .play-container {
      position: absolute;
      top: calc(50% - 30px);
      right: calc(50% - 30px);
    }
  }
  .payment-status {
    display: none;
  }
  .free-course {
    position: absolute;
    top: 16px;
    left: 16px;
    background: var(--secondary);
    z-index: 2;
    font: var(--smallRegular);
    padding: 2px .25rem;
  }
  .play-container {
    width: 80px;
    height: 80px;
    transition: 0.1s ease-in;
    transform: scale(0.7);
  }
  :active .play-container {
    transform: scale(0.95);
  }
  @media (min-width: 1024px) {
    margin-block-start: 0;
    position: sticky;
    top: calc(var(--headerBlockSize) + 24px);
    height: max-content;
    .payment-status {
      display: block;
      padding: 16px;
    }
  }
  @media (min-aspect-ratio: 10 / 4) {
    .video {
      max-width: 80%;
      margin: 0 auto;
      border-radius: 0;
    }
  }
`

function VideoCard() {
  const [playing, setPlaying] = useState(false)
  const query = useCourse()

  const { featured_video: { player_url, thumbnails }, is_free, has_access: hasCourseAccess } = query.data

  return (
    <VideoCardStyled aria-label="Preview del curso y status de pago">
      {is_free && !hasCourseAccess && (
        <div className="free-course">
          <span>Curso gratuito</span>
        </div>
      )}
      <div className="video" id="promo-video">
        {!playing
          ? (
            <div className="video-thumb" id="video-card-hover" onClick={() => setPlaying(true)}>
              <img width="436" height="244.5625" className="thumb" src={thumbnails && thumbnails[0].link} alt="thumbnail del video de la presentacion del curso" />
              <div className="play-container">
                <PlayAnimated width="60px" height="60px" color="white" />
              </div>
            </div>)
          : (
            <VideoCardLazy videoUrl={player_url} />
          )
        }
      </div>
      <div className="payment-status">
        <PaymentStatus />
      </div>
    </VideoCardStyled>
  )
}

export default VideoCard
